import { SHStack } from "@components/design-systems/sh-stack";
import { Controller, useFormContext } from "react-hook-form";
import {
  AnalysisSetupDTO,
  AnalysisSetupStepRenderedFieldProps,
} from "@models/platform-analysis/entities/steps/setup";
import { MAX_MEDIUM_TEXT_LENGTH } from "@constants";
import SHRichTextEditorV2 from "@components/design-systems/sh-rich-text-editor-v2";

export const AnalysisSetupStepObjectivesField = ({
  userType,
  disabled,
}: AnalysisSetupStepRenderedFieldProps) => {
  const { control } = useFormContext<AnalysisSetupDTO>();

  return (
    <SHStack
      spacing={3}
      direction="column"
      sx={{ width: { xs: "100%", md: 520 } }}
    >
      <Controller
        name="objectives"
        control={control}
        render={({ field }) => (
          <SHRichTextEditorV2
            {...field}
            maxCharacters={MAX_MEDIUM_TEXT_LENGTH}
            placeholder={
              userType === "supplier"
                ? "Enter your objectives for this analysis"
                : "Enter your client's situation and needs"
            }
            isDisabled={disabled}
            styledContainerSx={{
              "& .editor-container": {
                height: "auto" 
              },
              "& .editor-inner": {
                maxHeight: 245,
              },
            }}
          />
        )}
      />
    </SHStack>
  );
};
